import Box from '../../../components/Box'

const TipsterOverview = () => {
    return <Box title="Overview" className="flex-1"></Box>
}

export default TipsterOverview
